import {createAction, createSlice} from '@reduxjs/toolkit';

export const bypassExpenseInitialState = {
  activeStatus: true,
  toggleStatus: true,
  isLoading: false,
  bypassExpenseGridData: [],
  bypassExpenseGridLoading: false,
  bypassExpenseSelectedExpenseIds: [],
};

export const fetchBypassExpensePendingReportCreator = createAction<any>(
  'BYPASS_EXPENSE_HANDLER/FETCH_PENDING_REPORT',
);
export const fetchBypassExpensePendingReportCreatorTypeName =
  fetchBypassExpensePendingReportCreator({}).type;

export const approveBypassExpensesCreator = createAction<any>(
  'BYPASS_EXPENSE_HANDLER/APPROVE_EXPENSES',
);
export const approveBypassExpensesCreatorTypeName =
  approveBypassExpensesCreator({}).type;

const bypassExpenseStateHandler = createSlice({
  name: 'BYPASS_EXPENSE_HANDLER',
  initialState: bypassExpenseInitialState,
  reducers: {
    setActiveStatus: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        activeStatus: payload,
      };
    },
    setActiveStatusInApproveScreen: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        toggleStatus: payload,
      };
    },
    setIsLoading: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        isLoading: payload,
      };
    },
    setBypassExpenseGridData: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        bypassExpenseGridData: payload,
      };
    },
    setBypassExpenseGridLoading: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        bypassExpenseGridLoading: payload,
      };
    },
    setBypassExpenseSelectedExpenseIds: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        bypassExpenseSelectedExpenseIds: payload,
      };
    },
  },
});

export const bypassExpenseStateActions = bypassExpenseStateHandler.actions;
export const bypassExpenseStateReducer = bypassExpenseStateHandler.reducer;
